module.exports = {"yytx05":{"daobanList":[{"title":"1:是否办理社会失业申办退休人员纳入社会服务管理","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、广州市退休人员个人情况登记表","state":"必要"},{"name":"2、户口本、身份证或者社保卡","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx05.json
// module id = 1304
// module chunks = 0